import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    credits: PropTypes.array.isRequired,
};

const defaultProps = {
    credits: [],
};

class Credits extends Component {

    constructor(props) {
        super(props);
        this.renderSection = this.renderSection.bind(this);
        this.renderCredit = this.renderCredit.bind(this);
    }

    renderSection(section) {
        const credits = section.items.map(this.renderCredit);
        return (
            <div key={`part_credit_section_${section.label}`} className="credit-section">
                <h5 className="credit-title">{section.label}</h5>
                <ul>
                    { credits }
                </ul>
            </div>
        );
    }

    renderCredit(credit, id) {
        return (
            <li key={`part_credit_${credit}_${id}`} className="credit">{credit}</li>
        );
    }

    render() {
        const { credits } = this.props;
        return (
            <div className="container credits-container">
                { credits.map(this.renderSection) }
            </div>
        );
    }
}

Credits.propTypes = propTypes;
Credits.defaultProps = defaultProps;

export default Credits;



// WEBPACK FOOTER //
// ./components/partials/Credits.jsx